// Modal.tsx
import React from 'react';
import { ModalVariantContext, ModalVariant } from './ModalContext';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  variant?: ModalVariant;
  size?: string;
  ignoreOutsideClick?: boolean
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, variant = 'neutral', size='normal',
                                       ignoreOutsideClick = false }) => {
  const variantClasses = {
    neutral: {
      background: 'bg-indigo-900',
    },
    warning: {
      background: 'bg-cherry-200',
    },
    dark: {
      background: 'bg-indigo-1000',
    }
  };

  const clickOutside = () => {
    if (!ignoreOutsideClick && onClose) {
      onClose()
    }
  }

  let sizeCls = "w-full max-w-lg mx-4";
  if (size === 'large') {
    sizeCls = "z-modal-large";
  } else if (size === "wide") {
    sizeCls = "z-modal-wide";
  }

  return (
    <div
      className={`fixed inset-0 z-50 ${isOpen ? 'flex' : 'hidden'} items-center justify-center rounded-[16px]`}
      role="dialog"
      aria-modal="true"
    >
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-40 bg-scrim/80 dark:bg-scrim/80"
        onClick={clickOutside}
      />


      {/* Modal content */}
      <ModalVariantContext.Provider value={variant}>
        <div
          className={`relative z-no-scrollbar ${variantClasses[variant].background} rounded-[16px] shadow-lg z-50 ${sizeCls} desktop:mx-0 `}
          style={{maxHeight: 'calc(100dvh - 16px)', overflowY: 'scroll'}}
        >
          {children}
        </div>
      </ModalVariantContext.Provider>
    </div>
  );
};

export default Modal;
